import React from 'react';
import { __ } from 'first-intl';
import { TRACK_ID } from '@hugendubel/tracking_client';
import { A } from '@hugendubel/react-basic';
import { ORDER_RETURN, TERMS_AND_CONDITIONS } from '../../external-urls';

export const LegalInfo: React.FC = () => (
    <div className="col-sm-12">
        <p className="legal-notice">
            {__('page.DeliveryAddressSelection.legalnote.1')}
            <A trackId={TRACK_ID('2019-07-31 03:25:37')} href={TERMS_AND_CONDITIONS} target="_blank">
                {__('page.DeliveryAddressSelection.legalnote.agb')}
            </A>
            {__('page.DeliveryAddressSelection.legalnote.2')}
            <A trackId={TRACK_ID('2019-07-31 03:25:37')} href={ORDER_RETURN} target="_blank">
                {__('page.DeliveryAddressSelection.legalnote.return')}
            </A>
            .
        </p>
    </div>
);
